import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_u6rg7kp9c7: FaireCollectionEntity = {
  token: "pbc_u6rg7kp9c7",
  type: "collection",
  name: "Graduation",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c5b39bf523550a405ddd367369d1eacc2246318e638f49a07540a9fc81e8ef2b.jpeg",
  itemCount: 2,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:24.456Z",
    importedBy: "entity-db-import-collections",
  },
};
